import React from "react";
import { Link, useLocation } from "react-router-dom";
import { NewsletterForm } from "@/components/NewsletterForm";

const LINKS = [["/courses", "Courses"], ["/pricing", "Pricing"], ["/articles", "Theory articles"], ["/faqs", "FAQs"], ["/about", "About Jason"], ["/keep-in-touch", "Let's keep in touch"]];

export const SiteFooter = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin") || pathname.startsWith("/keep-in-touch")) return null;
  return (
    <footer className="mt-16 border-t border-border bg-card/60" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-12 sm:px-8 lg:grid-cols-[1.3fr_1fr]">
        <div data-testid="footer-newsletter">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-primary">Let's keep in touch</p>
          <h2 className="mt-2 font-serif text-2xl">Offers, new lessons and updates from Jason</h2>
          <div className="mt-5 max-w-xl"><NewsletterForm id="footer" compact source="footer" page={pathname} /></div>
        </div>
        <nav className="grid content-start gap-2 text-sm sm:grid-cols-2" aria-label="Footer">
          {LINKS.map(([to, label]) => (
            <Link key={to} to={to} className="text-muted-foreground transition-colors hover:text-primary" data-testid={`footer-link-${to.slice(1)}`}>{label}</Link>
          ))}
          <p className="mt-4 text-xs text-muted-foreground sm:col-span-2">© {new Date().getFullYear()} The JT Hub · Jason Thompson</p>
        </nav>
      </div>
    </footer>
  );
};
